module.exports = __webpack_public_path__ + "static/media/UrlLinkWhite.e9b1b6a1.svg";